import { browserName } from 'react-device-detect';

export const copyToClipboard = async (text: string) => {
  try {
    let allowed = false;

    // Safari doesn't have clipboard permissions available, so bypass
    if (['Safari', 'Firefox'].includes(browserName)) {
      allowed = true;
    }
    // Otherwise ensure we have permission to write to clipboard
    else {
      const permissionStatus = await navigator.permissions.query({
        name: 'clipboard-write' as PermissionName
      });
      allowed =
        permissionStatus.state === 'granted' ||
        permissionStatus.state === 'prompt';
    }

    if (allowed) {
      navigator.clipboard.writeText(text);
    }
  } catch (e) {
    console.error(e);
  }
};
